var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"layout-content"},[_c('el-aside',{attrs:{"width":"250px"}},[_vm._t("left")],2),_c('el-main',[_c('div',{staticClass:"content"},[_vm._t("content")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }